import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TipoCarrera } from 'src/app/models/enum/tipo-carrera.enum';
import { TipoNivelEstudios } from 'src/app/models/enum/tipo-nivel-estudios.enum';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';

@Component({
  selector: 'app-antecedentes-conviviente',
  templateUrl: './antecedentes-conviviente.component.html',
  styleUrls: ['./antecedentes-conviviente.component.css']
})
export class AntecedentesConvivienteComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  tiposNivelEstudios : TipoNivelEstudios | any = TipoNivelEstudios;
  tiposCarrera : TipoCarrera | any = TipoCarrera;
  persona: any;
  constructor(private fb: FormBuilder,
     private stepperService: StepperService,
      private dataService: DataService,
       private personaService: PersonaService,
        private commonService: CommonService) {
    this.form = this.fb.group({
      guid: new FormControl(null),
      rut: new FormControl('', [Validators.required, this.commonService.createRutValidator(), Validators.pattern(/^[1-9]\d*[-|‐]{1}[0-9kK]{1}$/)]),
      apellidoPaterno: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
      apellidoMaterno: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
      nombre: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]),
      celular: new FormControl('', [Validators.required, Validators.pattern(/^(\+?56)?(\s?)(0?9)(\s?[98765432])\d{7}$/)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      nivelEstudios: new FormControl(null, [Validators.required]),
      tipoCarrera: new FormControl(null, [Validators.required]),
      carrera: new FormControl('', [Validators.required]),
      anoCursa: new FormControl(null, [Validators.required]),
      sueldo: new FormControl(null),
      honorarios: new FormControl(null),
      retiros: new FormControl(null),
      arriendos: new FormControl(null),
      otros: new FormControl(null),
      totalIngresos: new FormControl(null)
    });
  }
  ngOnInit(): void {
    this.form.get('anoCursa')?.disable();
    this.form.get('tipoCarrera')?.disable();
    this.form.get('carrera')?.disable();
    this.personaService.persona$.subscribe((persona) => {
      if (persona) {
        this.persona = persona;
        this.commonService.setFormGroupValues(this.form, persona.estadoSituacion?.personaAntecedentesConviviente);
        this.nivelEstudiosChange(persona.estadoSituacion?.personaAntecedentesConviviente?.nivelEstudios);
        this.tipoCarreraChange(persona.estadoSituacion?.personaAntecedentesConviviente?.tipoCarrera);
        this.sumaIngresos();
       if (persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
          this.form.disable();
        }
    }});

    
  }

  onSubmit() {
    if(this.persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado'){
      this.stepperService.nextStep();  
      return;
    }
    if(!this.form.invalid) {
      if(this.form.get('guid')?.value == null){
        this.form.removeControl('guid');
      }
      const formData = this.form.getRawValue();
      const guidAntecedentesConviviente = this.persona.estadoSituacion?.personaAntecedentesConvivienteId;
      if (guidAntecedentesConviviente) {
        formData.guid = guidAntecedentesConviviente;  
      }
      var url = `estado-situacion/${this.personaService.getPersonaGuid()}/antecedentes-conviviente`;
      this.dataService.postData(formData, url).subscribe({
        next: (v) => {
          this.stepperService.nextStep();   
        },
        error: (e) => console.log(e),
        complete: () => {
          this.personaService.setPersona();
        },
      });
    }else{
      this.form.markAllAsTouched();
    }
  }

  getTipoNivelEstudiosKeys(): string[] {
    return Object.keys(TipoNivelEstudios).sort();
  }

  nivelEstudiosChange(event: any){
    if(event === "EducacionBasica" || event === "EducacionMedia" || event === null || event === undefined){
      this.form.get('tipoCarrera')?.disable();
      this.form.get('carrera')?.disable();
      this.form.get('anoCursa')?.disable();
      this.form.get('tipoCarrera')?.setValue(null);
      this.form.get('carrera')?.setValue(null); 
      this.form.get('anoCursa')?.setValue(null);
    }else{
      this.form.get('tipoCarrera')?.enable();
      this.form.get('carrera')?.enable();
      this.form.get('anoCursa')?.enable();
    }
  
  }
  
  getTipoCarreraKeys(): string[] {
    return Object.keys(TipoCarrera).sort();
  }

  sumaIngresos(){
    var sueldo = this.form.get('sueldo')?.value;
    var honorarios = this.form.get('honorarios')?.value;
    var retiros = this.form.get('retiros')?.value;
    var arriendos = this.form.get('arriendos')?.value;
    var otros = this.form.get('otros')?.value;

    var totalIngresos = sueldo + honorarios + retiros + arriendos + otros;
    if(totalIngresos === 0){
      totalIngresos = null;
    }
    this.form.get('totalIngresos')?.setValue(totalIngresos);
  }

  onPhoneInput() {
    const phoneControl = this.form.get('celular');
    if (phoneControl) {
      let value = phoneControl.value || '';
      // Agregar +569 si no está presente y el campo no está vacío
      if (value && !value.startsWith('+569')) {
        value = '+569' + value.replace(/[^0-9]/g, ''); // Solo números después del prefijo
      }
      phoneControl.setValue(value, { emitEvent: false }); // Actualizar sin disparar eventos adicionales
    }
  }
  

  volver(){
    this.stepperService.prevStep();
  }
  tipoCarreraChange(event: any): void {
    const anoCursaControl = this.form.get('anoCursa');
    if (event === 'Incompleta') {
      anoCursaControl?.enable();
    } else {
      anoCursaControl?.disable();
      anoCursaControl?.setValue(null);
    }
  }
}
